"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CompleteIcon = void 0;
const react_1 = require("react");
const React = require("react");
class CompleteIcon extends react_1.Component {
    render() {
        return (React.createElement("svg", { width: "40px", height: "40px", viewBox: "0 0 40 40", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
                React.createElement("g", null,
                    React.createElement("g", { transform: "translate(13.000000, 13.000000)" },
                        React.createElement("rect", { id: "Rectangle", fill: "#52E271", x: "0", y: "0", width: "14", height: "14", rx: "7" }),
                        React.createElement("g", { fill: "#FFFFFF" },
                            React.createElement("path", { d: "M5.6662706,2.8317166 L5.6662706,9.8317166 L4.2662706,9.8317166 L4.2662706,2.8317166 L4.2662706,1.4317166 L9.8662706,1.4317166 L9.8662706,2.8317166 L5.6662706,2.8317166 Z", transform: "translate(7.066271, 5.631717) rotate(-134.000000) translate(-7.066271, -5.631717) " })))))));
    }
}
exports.CompleteIcon = CompleteIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/complete.tsx
// module id = 2135
// module chunks = 0 1 2